const data = {};
let isLocalStorageSupport = true;

const prefix = key => `vespa-${key}`;

export const detectLocalStorageSupport = () => {
	try {
		window.localStorage.setItem('test', '1');
		window.localStorage.removeItem('test');
	} catch (e) {
		console.warn('Does not support localStorage', e);
		isLocalStorageSupport = false;
	}
};

const setItem = (key, value) => {
	const prefixKey = prefix(key);

	if (isLocalStorageSupport) {
		window.localStorage.setItem(prefixKey, value);
		return;
	}

	data[prefixKey] = value;
};

const getItem = key => {
	const prefixKey = prefix(key);

	if (isLocalStorageSupport) {
		return window.localStorage.getItem(prefixKey);
	}

	if (Object.hasOwnProperty.call(data, prefixKey)) {
		return data[prefixKey];
	}

	return null;
};

const removeItem = key => {
	const prefixKey = prefix(key);

	if (isLocalStorageSupport) {
		window.localStorage.removeItem(prefixKey);
		return;
	}

	if (Object.hasOwnProperty.call(data, prefixKey)) {
		delete data[prefixKey];
	}
};

const clearAllToken = () => {
	// Remove wrapper-managed token => localStorage['vespa-token']
	removeItem('token');

	// Remove legacy/unprefixed token => localStorage['token']
	try {
		window.localStorage.removeItem('token');
		// In case previous implementations wrote directly to the prefixed key
		window.localStorage.removeItem(prefix('token'));
	} catch (e) {
		// Ignore storage errors (e.g. blocked localStorage in some WebViews)
	}

	// Also clear possible in-memory fallback entries
	if (Object.hasOwnProperty.call(data, 'token')) {
		delete data.token;
	}
};

export default {
	setItem,
	getItem,
	removeItem,
	clearAllToken,
};
